import {Component, forwardRef, OnInit} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { ExpressionBuilderModel } from '../expression-builder.model';
import { QueryBuilderConfig, RuleSet } from 'angular2-query-builder';
import { EXPRESSION_FIELD_SCOPE } from 'src/app/app.models';

@Component({
    selector: 'abw-expression-builder-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ExpressionBuilderFormComponent),
        
        multi: true
      }
    ],
    templateUrl: './expression-builder-form.component.html',
    styleUrls: ['./expression-builder-form.component.scss']
})
export class ExpressionBuilderFormComponent extends AbstractWorkflowFormComponent<ExpressionBuilderModel, any> implements OnInit {
    EXPRESSION_FIELD_SCOPE = EXPRESSION_FIELD_SCOPE;
    query = {
      condition: 'and',
      rules: []
    };
    
    config: QueryBuilderConfig = {
      fields: {},
      addRule: (parent: RuleSet) => {
        if (Object.keys(this.config.fields).length > 0) {
          const field = this.config.fields[Object.keys(this.config.fields)[0]];
          const newRule: any = {
            field: field.value,
            operator: 'eq',
            value: null,
            entity: undefined,
            scope: EXPRESSION_FIELD_SCOPE.CONSTANT
          };
          parent.rules = parent.rules.concat([newRule]);
        }
      }
    }

    operators = [
      { value: 'eq', label: 'Est égal à' },
      { value: 'neq', label: 'Est différent de' },
      { value: 'gte', label: 'Est supérieur ou égal à' },
      { value: 'gt', label: 'Est supérieur à' },
      { value: 'lte', label: 'Est inférieur ou égal à' },
      { value: 'lt', label: 'Est inférieur à' },
      { value: 'isnull', label: 'Est nul' },
      { value: 'isnotnull', label: 'Est non nul' },
      { value: 'contains', label: 'Contiens' },
      { value: 'not_contains', label: 'Ne contiens pas' },
      { value: 'in_datasource', label: 'Contenu dans source de données', datasource: true },
      { value: 'not_in_datasource', label: 'N\'est pas contenu dans source de données', datasource: true },
    ];

    ngOnInit() {
      super.ngOnInit();
      this.datasourceComponentRefreshed = false;
      const fields: any = {};
      this.model.datasource.forEach(d => {
        fields[d.ID] = {
          name: d.TEXT,
          type: 'custom',
          operators: this.operators,
          scope: EXPRESSION_FIELD_SCOPE.CONSTANT,
          defaultOperator: 'eq'
        };
      });
      this.config.fields = fields;
      setTimeout(() => this.datasourceComponentRefreshed = true, 10);
    }

    writeValue(value: any) {
      if (!!value && !!value.rules) {
        value.rules = value.rules.filter(rule => !!this.config.fields[rule.field]);
      }
      super.writeValue(value);
      this.query = value;
    }

    getDatasourceColumns(rule: any) {
      let columns = [];
      if (rule.scope == EXPRESSION_FIELD_SCOPE.DATASOURCE) {
        const datasource = this.model.datasources.find(d => d.NUM_DATASOURCE == rule.value);
        if (datasource !== undefined) {
          columns = datasource.DS_PARAMS.DS_COLUMNS;
        }
      }
      return columns;
    }

    onChange(_expression: any) {
      this.propagateChange(_expression);
    }

    isRuleDatasource(rule: any) {
      const ruleOperator = this.operators.find(op => op.value == rule.operator);
      if (!ruleOperator) { return false; }
      return ruleOperator.datasource !== undefined && ruleOperator.datasource === true;
    }
}